<template>
  <div class="subscription-page row" :class="isTestPage ? 'hide-header' : ''">
    <div class="col-12">
      <StepProgress
        v-if="!isTestPage"
        :hasTests="
          opportunity.opportunity_tests &&
          opportunity.opportunity_tests.length > 0
        "
      />

      <div class="row">
        <div class="col-12 col-lg-8 mx-auto">
          <router-view :key="$route.fullPath"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hero from "@/components/media/Hero.vue";
import StepProgress from "@/components/StepProgress.vue";

export default {
  name: "Subscription",

  data() {
    return {
      opportunity: {},
    };
  },

  computed: {
    isTestPage() {
      return this.$route.name == "capa-teste" || this.$route.name == "pending-tests" || this.$route.name == "teste"
    },
  },

  components: {
    Hero,
    StepProgress,
  },

  head() {
    return this.$head({
      title: "",
      canonical: ``,
      meta_description: "",
    });
  },

  created() {
    this.getOpportunity();
  },

  methods: {
    getOpportunity() {
      // Como ML pode ser Labs também, então fazemos uma dupla consulta e temos um counter para não haver loop infinito
      let counter = 0;

      const get = () => {
        this.$store
          .dispatch("opportunities/getOpportunity", this.$route.params.id)
          .then((opportunity) => {
            if (opportunity) {
              this.opportunity = opportunity;

              if (
                this.opportunity.status_id != 1 &&
                this.$route.name != "capa-teste"
              ) {
                this.$swal({
                  title: "Uoops",
                  html: "Inscrições Encerradas",
                  type: "error",
                });
                this.$router.push(`/`);
                return false;
              }

              this.notFound = false;
              this.pageTitle = this.$helpers.toTitle(this.opportunity.title);
              this.$emit("updateHead");
            }  else {
              this.notFound = true;
            }
          });
      };

      get();
    },

    getClass() {
      return this.$router.history.current["path"] ===
        `/vagas/${this.$route.params["id"]}/inscricao/escala-de-crencas`
        ? "full-height"
        : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.subscription-page {
  min-height: 100vh;
  background: #F5F5F5;
  /* margin-top: 123px; */

  &.hide-header{
    margin-top: 0;
  }

  /deep/ form .form-row{
    align-items: flex-end;
  }

  /deep/ .card-nav-tabs {
    background-color: #fff;
    position: sticky;
    top: 78px;
    z-index: 20;

    ul {
      justify-content: center;
      outline: none;

      li {
        a {
          color: color("gray");
          border-bottom: 2px solid theme-color("white");
          padding-left: 1rem;
          padding-right: 1rem;
          outline: none;
          &.active {
            border-bottom-color: theme-color("color-1");
            color: theme-color("color-1");
          }
        }
      }
    }
  }
}
</style>